import Admin, { Role, hasRole } from '@/models/Admin'
import User from '@/models/User'

export default class UserPolicy {
	viewAny(admin: Admin) {
		return true
	}

	view(admin: Admin, user: User) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	update(admin: Admin, user: User) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	restore(admin: Admin, user: User) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	delete(admin: Admin, user: User) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	forceDelete(admin: Admin, user: User) {
		return hasRole(admin, Role.ADMIN)
	}

	trash(admin: Admin) {
		return hasRole(admin, Role.ADMIN)
	}
}
